import apiClient from '../../client';
import { URLS } from '../../../constants';

const alertsService = {
  getAlertCategories: (): Promise<any> =>
    apiClient.post(URLS.getCategoryDataForAlert, {
      data: { categoryType: 'ALERT_TYPE' },
    }),

  getRecipients: (recipientType: 'CLIENT' | 'EMPLOYEE'): Promise<any> =>
    apiClient.post(URLS.getRecipientDataForAlert, {
      data: { recipientType },
    }),

  saveAlert: (payload: {
    alertId?: string;
    recipientType: string;
    categoryType: string;
    title: string;
    recipientData: number[];
    description: string;
    expiryDate?: string;
  }): Promise<any> => apiClient.post(URLS.saveAlertData, { data: payload }),

  getAlerts: (
    alertStatus: 'Unread' | 'Read' | 'Sent',
    pagination: { startIndex: number; noOfRecords: number } = { startIndex: 0, noOfRecords: 20 }
  ): Promise<any> =>
    apiClient.post(URLS.getAlertDataByStatus, {
      data: {
        heading: '',
        alertStatus,
        pagination,
        filter: [{ filterKey: '', filterValue: '' }],
        sorting: { order: 'DESC', fieldName: 'createdDate' },
      },
    }),

  getAlertById: (alertId: string): Promise<any> =>
    apiClient.post(URLS.getAlertById, { data: { alertId } }),

  markAlertRead: (alertId: string): Promise<any> =>
    apiClient.post(URLS.markAlertAsRead, { data: { alertId } }),

  deleteAlert: (alertId: string): Promise<any> =>
    apiClient.post(URLS.deleteAlertData, { data: { alertId } }),
};

export default alertsService;
